import { Routes } from '@angular/router';
import { AuthGuard } from '@core/services/guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'docs',
    pathMatch: 'full',
  },
  {
    path: 'not-authorized',
    loadComponent: () =>
      import('@pages/index').then((m) => m.PagesNotAuthorizedComponent),
  },
  {
    path: 'docs',
    loadComponent: () =>
      import('@pages/index').then((m) => m.PageMainDocsComponent),
    children: [
      {
        path: '',
        redirectTo: 'introduction',
        pathMatch: 'full',
      },
      {
        path: 'introduction',
        title: 'introduction',
        loadComponent: () =>
          import('@pages/docs/components').then(
            (m) => m.PageDocsIntroductionComponent
          ),
      },
      {
        path: 'what-api-do',
        title: 'what-api-do',
        loadComponent: () =>
          import('@pages/docs/components').then(
            (m) => m.PageDocsWhatApiDoComponent
          ),
      },
      {
        path: 'use-cases',
        title: 'use-cases',
        loadComponent: () =>
          import('@pages/docs/components').then(
            (m) => m.PageDocsUseCasesComponent
          ),
      },
      {
        path: 'authentication',
        title: 'authentication',
        loadComponent: () =>
          import('@pages/docs/components').then(
            (m) => m.PageDocsAuthenticationComponent
          ),
      },
      {
        path: 'endpoints',
        title: 'endpoints',
        loadComponent: () =>
          import('@pages/docs/components').then(
            (m) => m.PageDocsEndpointsComponent
          ),
      },
      {
        path: 'data-models',
        title: 'data-models',
        children: [
          {
            path: '',
            title: 'data-models',
            loadComponent: () =>
              import('@pages/docs/components').then(
                (m) => m.PageDocsDataModelsComponent
              ),
          },
          {
            path: ':id',
            title: 'detail',
            loadComponent: () =>
              import('@pages/docs/components').then(
                (m) => m.PageDocsDataModelsDetailComponent
              ),
          },
        ],
      },
    ],
  },
  {
    path: 'app',
    // canActivate: [AuthGuard],
    loadComponent: () =>
      import('@pages/index').then((m) => m.PagesMainComponent),
    children: [
      {
        path: '',
        redirectTo: 'medical-encounter',
        pathMatch: 'full',
      },
      {
        path: 'settlement',
        children: [
          {
            path: '',
            redirectTo: 'new',
            pathMatch: 'full',
          },
          {
            path: 'new',
            loadComponent: () =>
              import('@pages/settlement/settlement.component').then(
                (m) => m.PageSettlementComponent
              ),
          },
          {
            path: 'consult/:settlementId',
            loadComponent: () =>
              import('@pages/settlement/settlement.component').then(
                (m) => m.PageSettlementComponent
              ),
          },
        ],
      },
      {
        path: ':pageId',
        children: [
          {
            path: '',
            redirectTo: 'new-claim',
            pathMatch: 'full',
          },
          {
            path: 'new-claim',
            loadComponent: () =>
              import('@pages/main2/main2.component').then(
                (m) => m.PagesMain2Component
              ),
          },
          {
            path: 'consult-claim/:claimId',
            loadComponent: () =>
              import('@pages/main2/main2.component').then(
                (m) => m.PagesMain2Component
              ),
          },
          {
            path: 'continue-process-claim/:preauthorizedClaimId',
            loadComponent: () =>
              import('@pages/main2/main2.component').then(
                (m) => m.PagesMain2Component
              ),
          },
        ],
      },
    ],
  },
  {
    path: '**',
    loadComponent: () =>
      import('@pages/index').then((m) => m.PagesNotFoundComponent),
  },
];
